module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"group":"Gruppe","region":"Region","search":"Suche","tenant":"Mandant","title":"Bezeichnung"},"en":{"group":"Group","search":"Search","region":"Region","tenant":"Tenant","title":"Title"}}')
  delete Component.options._Ctor
}
